import axios from "axios";
import {getField, updateField} from "vuex-map-fields";
import i18n from '@/i18n';
import Vue from "vue";


export default {
  namespaced: true,
  state: {
    fetched: false,
    isCallRecordFetching: false,
    calls:[],
    records:[]
  },
  getters: {
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
    handleRecordToState(state, data) {
      const item = state.records.find(
          (item) => Number(item.callId) === Number(data.callId)
      );
      if (item) {
        let upd = {callId:data.callId, isFetching: data.isFetching}
        if(data.file) upd['file'] = data.file
        Object.assign(item, upd);
      } else {
        state.records.push({callId:data.callId, file:data.file, isFetching: data.isFetching});
      }
    },
    updateRecordInState(state, data) {
      const item = state.records.find(
          (item) => Number(item.callId) === Number(data.callId)
      );
      if (!item) return;
      Object.assign(item, {callId:data.callId, file:data.file, isFetching: data.isFetching});
    },
  },
  actions: {
    async getCallRecord({ commit, state, dispatch }, payload){
      updateField(state, {path:'isCallRecordFetching', value:true});
      commit('handleRecordToState', {callId:payload.id, file:null, isFetching:true})
      return await axios.get(this._vm.$apiURL + '/call-record/'+payload.id)
        .then((response) => {
          if(response.data.status === 'success'){
            commit('handleRecordToState', {callId:payload.id, file:response.data.data, isFetching:false})
          } else {
            throw response.data.data
          }
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root:true});
        })
        .finally(()=>{
          commit('handleRecordToState', {callId:payload.id, isFetching:false})
        })
    },
    async get({ commit, state, dispatch }){
      updateField(state, {path:'fetched', value:false});
      return await axios.get(this._vm.$apiURL + '/calls')
        .then((response) => {
          updateField(state, {path:'calls', value:response.data});
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root:true});
        })
        .finally(()=>{
          updateField(state, {path:'fetched', value:true});
        })
    },
    remove({ commit, state, dispatch }, payload){
      this._vm.$confirm( {
        title : this._vm.i18n.t('common.confirm'),
        text : this._vm.i18n.t('common.confirm_remove'),
        cancelText : this._vm.i18n.t('common.no'),
        acceptText : this._vm.i18n.t('common.yes')
      } ).then( y =>{
        return axios.delete(this._vm.$apiURL+'/calls/'+payload.id)
          .then(response => {
            if(response.data.status==='success'){
              dispatch('get');
              this._vm.$inform( this._vm.i18n.t('common.success_remove') )
            }
          })
          .catch(error => {
            dispatch('common/showError', {'error': error}, {root:true});
          });
      }).catch( n => {} );
    },
  }
}
